import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_9336_49026)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.76943 0.244587C2.54329 0.526835 2.58754 0.93996 2.86826 1.16733L10.0696 7L2.86826 12.8327C2.58754 13.06 2.54329 13.4732 2.76943 13.7554C2.99556 14.0377 3.40645 14.0822 3.68717 13.8548L10.8885 8.02211C11.5372 7.49675 11.5372 6.50325 10.8885 5.97789L3.68717 0.145215C3.40645 -0.0821516 2.99556 -0.0376612 2.76943 0.244587Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9336_49026",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "currentColor"
		})
	}) })]
});
export default SvgArrowRight;
